
/**
 * @export
 * @enum {string}
 */
export enum SsoDataValidationStatus {
    VALID = 'VALID',
    INVALID = 'INVALID',
    NOT_INITIALIZED = 'NOT_INITIALIZED'
}